/** Max consecutive years shown in the annual/yield viewport before horizontal scroll. */
export const OUTCOME_VISIBLE_YEAR_CAP = 10;

/** Gap between bars within one year group (px). */
export const BAR_GROUP_INNER_GAP_PX = 4;

/** Minimum width of one year bar group (px). */
export const BAR_GROUP_MIN_WIDTH_PX = 72;

export const BAR_WIDTH_BY_SCENARIO_COUNT: Readonly<Record<number, number>> = {
  1: 30,
  2: 24,
  3: 20,
  4: 16,
  5: 12,
};

/** Minimum width of one year column in the per-year table (px), matching the 5rem floor in the stylesheet. */
export const YEAR_COLUMN_MIN_WIDTH_PX = 80;

/** Year snapshots that qualify for the summary table given a timeline. */
export const SNAPSHOT_YEARS: ReadonlyArray<number> = [3, 5, 10, 15, 20];
